import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-mine-nxt',
  templateUrl: './footer-mine-nxt.component.html',
  styleUrls: ['./footer-mine-nxt.component.scss']
})
export class FooterMineNxtComponent implements OnInit {
  public now: Date = new Date();
  constructor() {
    setInterval(() => {
      this.now = new Date();
    }, 1);
   }

  ngOnInit(): void {
  }

}
